import type { SVGProps } from "react";
import * as React from "react";

const SvgAtSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 8a1 1 0 1 0-2 0zm-1 5h-1zm6 0h1zm0-1h1zm-3.312 8.734a1 1 0 1 0-1.216-1.588zM15 12a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3V7a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm3-1v5h2V8zm0 5a4 4 0 0 0 1.172 2.828l1.414-1.414A2 2 0 0 1 17 13zm1.172 2.828A4 4 0 0 0 19 17v-2a2 2 0 0 1-1.414-.586zM19 17a4 4 0 0 0 2.828-1.172l-1.414-1.414A2 2 0 0 1 19 15zm2.828-1.172A4 4 0 0 0 23 13h-2a2 2 0 0 1-.586 1.414zM23 13v-1h-2v1zm0-1a11 11 0 0 0-2.383-6.837L19.05 6.406A9 9 0 0 1 21 12zm-2.383-6.837A11 11 0 0 0 14.5 1.288l-.455 1.948a9 9 0 0 1 5.005 3.17zM14.5 1.288a11 11 0 0 0-7.2.767l.855 1.808a9 9 0 0 1 5.89-.627zm-7.2.767a11 11 0 0 0-5.163 5.076l1.793.885a9 9 0 0 1 4.225-4.153zM2.137 7.131a11 11 0 0 0-.89 7.186l1.955-.421a9 9 0 0 1 .728-5.88zm-.89 7.186a11 11 0 0 0 3.769 6.182l1.27-1.545a9 9 0 0 1-3.084-5.058zm3.769 6.182a11 11 0 0 0 6.795 2.5l.034-2a9 9 0 0 1-5.56-2.045zm6.795 2.5a11 11 0 0 0 6.877-2.265l-1.216-1.588A9 9 0 0 1 11.845 21z"
    />
  </svg>
);
export default SvgAtSign;
